import { styled } from 'styled-components'

export const Viewer = styled.div`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.space[12]};
  justify-content: center;
`

export const Image = styled.img`
  display: block;
  flex: 1;
  min-width: 0;
  max-height: 70vh;
  object-fit: contain;
`

export const Counter = styled.div`
  margin-top: ${({ theme }) => theme.space[12]};
  text-align: center;
`
